module.exports = __webpack_public_path__ + "img/anon.456d8d0f.svg";